import { useState, useCallback } from "react";
import { useAuthenticatedFetchWithWorkspace } from "../../Keycloak/useAuthenticatedFetchWithWorkspace";

interface CreateCustomersListParams {
    label: string;
    description: string;
    fileToImport: File;
    fileContainsHeader: boolean;
    isEmailList: boolean;
    isCellphoneList: boolean;
    isPersonidList: boolean;
    isCardList: boolean;
    isWalletList: boolean;
}

interface CreateCustomersListResponse {
    success?: boolean;
    message?: string;
    id?: string | number;
    importedCount?: number;
    errors?: string[];
    warnings?: string[];
}

const useCreateCustomersList = () => {
    const { authFetch } = useAuthenticatedFetchWithWorkspace();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>("");
    const [data, setData] = useState<CreateCustomersListResponse | null>(null);

    const createCustomersList = useCallback(async (params: CreateCustomersListParams): Promise<CreateCustomersListResponse | null> => {
        setLoading(true);
        setError("");
        setData(null);

        try {
            const formData = new FormData();
            formData.append("label", params.label);
            formData.append("description", params.description);
            formData.append("fileToImport", params.fileToImport);
            formData.append("fileContainsHeader", params.fileContainsHeader ? "1" : "0");
            formData.append("isEmailList", params.isEmailList ? "1" : "0");
            formData.append("isCellphoneList", params.isCellphoneList ? "1" : "0");
            formData.append("isPersonidList", params.isPersonidList ? "1" : "0");
            formData.append("isCardList", params.isCardList ? "1" : "0");
            formData.append("isWalletList", params.isWalletList ? "1" : "0");

            const result: CreateCustomersListResponse = await authFetch("/createCustomersList", {
                method: "POST",
                body: formData,
                headers: {
                    "Accept": "application/json",
                } as HeadersInit,
            });

            setData(result);
            return result;
        } catch (err: unknown) {
            const message = err instanceof Error ? err.message : "An unknown error occurred";
            if (err instanceof Error) {
                setError(err.message);
            } else {
                setError(message);
            }
            return { success: false, message };
        } finally {
            setLoading(false);
        }
    }, [authFetch]);

    return { createCustomersList, loading, error, data };
};

export default useCreateCustomersList;
